import React from "react";
import InnerHTML from "../base/InnerHtml";

const Banner = () => {
  return (
    <InnerHTML
      html={`<ins class="asm_async_creative" style="display:inline-block; width:1px; height:1px;text-align:left; text-decoration:none;" data-asm-cdn="cdn.web2media.sk" data-asm-host="turbo.web2media.sk" data-asm-params="pid=715&gdpr_consent=[consentstring]"></ins><script src="//cdn.web2media.sk/adasync.min.js" async type="text/javascript"></script> `}
    ></InnerHTML>
  );
};

export const Web2MediaDesktopSkinny = Banner;

export default Banner;
